const Types = {
    USER: {
        SUCCESS: 'USER/SUCCESS',
    },
    COMMON: {
        LOADER: 'COMMON/LOADER',
    },
    ORGANISATION: {
        LOADER: 'ORGANISATION/LOADER',
        SUCCESS: 'ORGANISATION/SUCCESS',
        DATA_CLEAR: 'ORGANISATION/DATA_CLEAR',
        GET_DATA: 'ORGANISATION/GET_DATA',
        UPDATE_DATA: 'ORGANISATION/UPDATE_DATA',
    },
    DOCUMENT: {
        SUCCESS: 'DOCUMENT_SUCCESS',
        ADD_NEW: 'DOCUMENT_ADD_NEW',
    },
    GENERATED_DOCUMENTS: "GENERATED_DOCUMENTS",
    PREVIEW_DOCUMENT: { UPDATE: 'PREVIEW_DOCUMENT_UPDATE' },
    DOCUMENT_ANALYSIS: { UPDATE: 'DOCUMENT_ANALYSIS_UPDATE' },
    NAVBAR_CONTENT: 'NAVBAR_CONTENT',
    NAVBAR_CONTENT_BTN_CLICK_STATUS: 'NAVBAR_CONTENT_BTN_CLICK_STATUS',
    LOGOUT: 'LOGOUT',
    UPLOAD_HISTORY: {
        PENDING: 'UPLOAD_HISTORY_PENDING',
        FULFILLED: 'UPLOAD_HISTORY_FULFILLED',
        ERROR: 'UPLOAD_HISTORY_ERROR'
    }
};

export default Types;
